import { useToggle } from "../../contexts/FeatureToggleContext";

/**
 * Conditionally render children based on a UI feature toggle.
 *
 *   <Gate flag="nav.todo">…</Gate>
 *
 * Renders children only when the flag resolves ON. For list/array filtering
 * (e.g. menu configs) use the useToggle hook directly instead.
 */
const Gate = ({ flag, children, fallback = null }) => {
  const on = useToggle(flag);
  return on ? children : fallback;
};

export default Gate;
